<template>
    <div class="signin-bg">
        <div class="img-box">
            <img class="logo" src="../assets/login_logo.png" alt="logo">
        </div>
        <div class="register-from">
            <router-link class="goBack" :to="{name:'Login'}">
            </router-link>
            <form action="#" ref="refisterForm" :model="refisterForm">
                <div class="inputbox">
                    <input type="text" name="email" id="email" autocomplete="off" v-model="refisterForm.user_name" placeholder="手机号/账号/账号"/>
                    <div class="slide">
                        <drag-verify ref="dragVerify"
                                     :width="width"
                                     :height="height"
                                     :text="text"
                                     :success-text="successText"
                                     :background="background"
                                     color="blue"
                                     :progress-bar-bg="progressBarBg"
                                     :completed-bg="completedBg"
                                     :handler-bg="handlerBg"
                                     :handler-icon="handlerIcon"
                                     :text-size="textSize"
                                     :success-icon="successIcon"
                                     :circle="isCircle">
                        </drag-verify>
                    </div>
                    <div :class="{visibility:false}">
                        <input class="verifcode" type="text" name="verifcode" id="verifcode" autocomplete="off" v-model="refisterForm.code" placeholder="请输入验证码"/>
                        <button class="getverifcode" :disabled="codeDisabled" @click.prevent="getCode">{{codeMsg}}</button>
                    </div>
                    <input type="password" name="password" id="password" autocomplete="off" v-model="refisterForm.password" placeholder="密码至少8位，必须含数字和字母"/>
                    <input type="password" name="password" id="password_confirm" autocomplete="off" v-model="refisterForm.password_confirmation" placeholder="确认密码，密码至少8位，必须含数字和字母"/>
                </div>
                <p class="btn_but">
                    <button class="signbtn" @click.prevent="signUp">注册</button>
                </p>
                <p class="already-sign">
                    <a href="javascript:;" style="float: left">
                        <span>
                            <input type="checkbox" name="agree" v-model="refisterForm.isAgree" class="agree" id="agree">
                            <label for="agree"></label>
                        </span>

                    </a>
                </p>
            </form>
        </div>
        <p class="copyright">ALL  RIGHTS  RESERVED.广州影美晴信息科技有限责任公司  粤B2-20150265 | 粤网文  （2018）8475-3059号 | 粤ICP备14050742号-1 | 粤公网备 44010502001214号</p>
    </div>
</template>

<script>
import dragVerify from "@/views/dragVerify";
import {setCookie} from "@/util/common";
export default {
    name: 'Register',
    data() {
        return {
            refisterForm: {
                user_name: '',
                code: '',
                password: '',
                password_confirmation: '',
                isAgree:''
            },
            codeMsg:'获取验证码',
            codeDisabled:false,
            handlerIcon: "fa fa-angle-double-right",
            successIcon: "fa fa-check",
            background: "#f7f7f7",
            color :"#999999",
            progressBarBg: "#4b0",
            completedBg: "#66cc66",
            handlerBg: "#fff",
            text: "请按住滑块、拖动到最右边",
            successText: "验证成功",
            width: 360,
            height: 48,
            textSize: "14px",
            isCircle:true,
        }
    },
    components:{
        dragVerify
    },
    mounted() {

    },
    methods: {
        getCode(){
            //获取验证码
            if(!this.refisterForm.user_name){
                this.$message({
                    message: '请填写手机号/账号',
                    type: 'error'
                });
                return
            }
            if(!this.$refs.dragVerify.isPassing){
                this.$message({
                    message: '请完成滑块校验',
                    type: 'error'
                });
                return
            }
            this.$post('reg/sendCode',{user_name:this.refisterForm.user_name})
                .then( res => {
                    if(res.code == 200){
                        this.$message({
                            showClose: true,
                            message: res.data,
                            type: 'success'
                        });
                        this.codeDisabled = true
                        this.count = 60;
                        this.timer = setInterval(()=>{
                            if(this.count > 0 && this.count <= 60){
                                this.count--;
                                this.codeMsg = this.count
                            }else{
                                clearInterval(this.timer);
                                this.timer = null;
                                this.codeDisabled = false
                                this.codeMsg = '获取验证码'
                                this.$refs.dragVerify.reset()
                            }
                        },1000)
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                })
                .catch(error => {
                    console.log(error.message)
                })
        },
        signUp(){
            this.$post('/register',this.refisterForm
            )
                .then( res => {
                    if(res.code ==200){
                        this.$message({
                            showClose: true,
                            message: "注册成功",
                            type: 'success'
                        });
                        let days = 0.5;
                        this.setCookie("token", res.data.access_token, days);
                        
                        this.$router.push({name:'Dashboard',query: {showDialogs:'1'}})
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }

                })
                .catch(error => {
                    console.log(error)
                })
        }
    }
}
</script>

<style scoped>
.goBack{
    float: left;
}
.title{
    font-size: 18px;
    color: #2a2a2a;
    font-family: MicrosoftYaHei;
}
.signin-bg{
    height: 1030px;
    background: url("../assets/bg.png");
}
.signin-bg .logo{
    margin: 146px auto 47px;
}
.register-from {
    width: 470px;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 20px;
    padding: 70px 65px 155px;
}
.register-from .tab a.active{
    color: #2a2a2a;
}
.register-from .tab a.active:before{
    display: block;
    content: '';
    position: absolute;
    left: 35%;
    bottom: -18px;
    width: 50px;
    height: 4px;
    background-color: #ff9f00;

}
.img-box{
    width: 100%;
    text-align: center;
}

.register-from .tab a{
    font-family: MicrosoftYaHei;
    position: relative;
    display: inline-block;
    width: 50%;
    text-align: center;
    font-size: 18px;
    color: #999999;
    cursor: pointer;
}
.register-from .line{
    width: 361px;
    height: 1px;
    background-color: #f7f7f7;

}
.register-from input {
    outline: none;
    padding-left: 15px;
    -webkit-appearance: none;
}
.register-from .inputbox{
    margin: 38px auto 20px;
}
#email,#password,#verifcode,#password_confirm{
    width: 361px;
    height: 48px;
    background-color: #f7f7f7;
    border-radius: 24px;
    border: none;
    font-size: 15px;
    margin: 11px 0;
}
#verifcode{
    width: 175px;
}
.getverifcode{
    width: 150px;
    height: 48px;
    background-color: #ffeccc;
    border-radius: 24px;
    font-size: 14px;
    color: #ff9f00;
    border: none;
    cursor: pointer;
    margin-left: 11px;
}
.getverifcode[disabled]{
    cursor: not-allowed;
    filter: alpha(opacity=65);
    -webkit-box-shadow: none;
    box-shadow: none;
    opacity: .65;
}
.visibility{
    display: none;
    /*overflow: hidden;*/
}

.agree-txt{
    font-size: 14px;
    color: #999999;
    text-align: left;
}

.agree {
    position: absolute;
    width: 20px;
    height: 20px;
    visibility: hidden;
}
.agree + label {
    display: inline-block;
    width: 20px;
    height: 20px;
    /*background: url("../assets/signin/combobox_unselect.png") no-repeat;*/
    vertical-align: middle;
}
.agree:checked + label {
    /*background: url("../assets/signin/combobox_select.png") no-repeat;*/
}
.signbtn {
    width: 361px;
    height: 48px;
    background-color: #ff9f00;
    border-radius: 24px;
    border: none;
    font-size: 16px;
    cursor: pointer;
    line-height: 28px;
    color: #ffffff;
}
.already-sign {
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0px;
    color: #666666;
}
.already-sign a {
    font-size: 14px;
    color: #999999;
    float: right;
}
.copyright{
    margin-top: 70px;
    font-size: 12px;
    text-align: center;
    color: #999999;
}
input::-webkit-input-placeholder {
    color: #999999;
    font-size: 16px;
}
input::-moz-placeholder {
    color: #999999;
    font-size: 16px;
}
input:-moz-placeholder {
    color: #999999;
    font-size: 16px;
}
input:-ms-input-placeholder {
    color: #999999;
    font-size: 16px;
}
.relat {
    position: relative;
}
.signbut:hover {
    background: #0293bf;
    text-decoration: none;
    color: #fff;
}
.btn_but {
    margin-top: 30px;
}
.signbut.disable{cursor: not-allowed;-webkit-box-shadow: none;box-shadow: none;opacity: .6;background-color: #00bde3;}
.signbut.disable:hover{background-color: #00bde3;}

.slide{
    position: relative;
    background-color: #f7f7f7;
    border-radius: 24px;
    height: 48px;
    line-height: 48px;
    margin: 11px 0;
}
.slide span{
    position: absolute;
    left: 0;
    display: inline-block;
    width: 48px;
    height: 48px;
    background-color: #ffffff;
    box-shadow: 0px 4px 6px 0px
    rgba(51, 51, 51, 0.1);
    border: solid 1px #e8e8e8;
    border-radius: 100%;
}
.slide p{
    font-size:14px;
    color: #999999;
}
</style>

